<template>
  <v-autocomplete
    hide-details="auto"
    :items="CustomerTypes"
    :loading="loading"
    v-model="filterDatas.customerType"
    item-text="name"
    item-value="id"
    label="Customer Type"
    clearable
    outlined
    dense
    @change="emitInput(filterDatas.customerType)"
    :search-input.sync="searchCustomers"
  ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    CustomerTypes: [],
    loading: false,
    searchCustomers: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_CUSTOMER_TYPE_FILTER', data);
      this.$emit('input', this.filterDatas.customerType);
    },
    GetCustomerType() {
      this.$store
        .dispatch('customer/GetCustomerType')
        .then((res) => {
          this.CustomerTypes = res.data.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.searchCustomers = null;
      },
      deep: true,
    },
    searchCustomers: {
      handler(val) {
        this.$store.commit(
          'UPDATE_CUSTOMERTYPE_AUTOCOMPLETE_QUERY_FILTER',
          val,
        );
        this.GetCustomerType(val);
      },
      deep: true,
    },
  },

  created() {
    this.$emit('input', this.filterDatas.customerType);
    this.GetCustomerType();
  },
};
</script>
